import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxsModule } from '@ngxs/store';
import { CreateUserPaymentDialogComponent } from '@x/ecommerce-shop/app/core/auth/components/create-user-payment-dialog/create-user-payment-dialog.component';
import { LoggedInComponent } from '@x/ecommerce-shop/app/core/auth/components/logged-in/logged-in.component';
import { IfLoggedOutDirective } from '@x/ecommerce-shop/app/core/auth/directive/if-logged-out.directive';
import { AuthErrorHandlerService } from '@x/ecommerce-shop/app/core/auth/services/auth-error-handler.service';
import { AuthService } from '@x/ecommerce-shop/app/core/auth/services/auth.service';
import { UserPaymentService } from '@x/ecommerce-shop/app/core/auth/services/user-payment.service';
import { AuthState } from '@x/ecommerce-shop/app/core/auth/state/auth.state';
import { RoutingModule } from '@x/ecommerce-shop/app/core/routing/routing.module';
import { ROOT_MODULE_ERROR_HANDLER } from '@x/ecommerce-shop/app/core/shop-error/shop-error-handler/shop-error-handler.service';
import { MenuUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/menu-ui/menu-ui.module';
import { NeedHelpModule } from '@x/ecommerce-shop/app/core/shop-ui/components/need-help/need-help.module';
import { OverlayUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/overlay/overlay-ui.module';
import { ShopDialogUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-dialog-ui/shop-dialog-ui.module';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { IconUiModule } from '../shop-ui/components/icon-ui/icon-ui.module';
import { AuthDialogComponent } from './components/auth-dialog/auth-dialog.component';
import { LoggedOutComponent } from './components/logged-out/logged-out.component';
import { IfLoggedInDirective } from './directive/if-logged-in.directive';

@NgModule({
  providers: [AuthService, UserPaymentService, AuthErrorHandlerService],
  declarations: [
    LoggedInComponent,
    LoggedOutComponent,
    IfLoggedInDirective,
    IfLoggedOutDirective,
    AuthDialogComponent,
    CreateUserPaymentDialogComponent,
  ],
  imports: [
    CommonModule,
    NgxsModule.forFeature([AuthState]),
    MatButtonModule,
    RouterModule,
    MatMenuModule,
    RoutingModule,
    OverlayModule,
    OverlayUiModule,
    FontAwesomeModule,
    UtilsModule,
    MenuUiModule,
    ShopDialogUiModule,
    IconUiModule,
    NeedHelpModule,
  ],
  exports: [LoggedInComponent, IfLoggedInDirective, LoggedOutComponent, IfLoggedOutDirective],
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [{ provide: ROOT_MODULE_ERROR_HANDLER, useClass: AuthErrorHandlerService }],
    };
  }
}
